import React, { createContext, useCallback, useEffect, useState } from 'react';
import useAuthUsers from '../hooks/useAuthUsers';
import DialogUpdateVersionContext from '../components/_dashboard/olimpo/versiones/UpdateVersion/DialogUpdateVersionContext';
import { firestore } from './FirebaseContext';

export const DescuentoCuponesContext = createContext({ descPaqueteriaData: {}, descPaqueteriaList: [] });

function DescuentoCuponesProvider({ children }) {
  const [descPaqueteriaData, setDescPaqueteriaData] = useState(null);
  const [descPaqueteriaList, setDescPaqueteriaList] = useState([]);

  const { currentUser, currentHostUser } = useAuthUsers();

  // console.log(currentUser, currentHostUser);

  // console.log(descPaqueteriaData);

  useEffect(() => {
    function getDescPaq(idDoc) {
      firestore
        .collection('desc_porPaqueteria')
        .doc(idDoc)
        .onSnapshot((doc) => {
          if (doc.exists) {
            setDescPaqueteriaData({ id: doc.id, ...doc.data() });
            setDescPaqueteriaList([...doc.data().listPaqDesc]);
          }
        });
    }

    const arrRolesPermitidos = ['cliente-corporativo', 'almighty'];

    if (arrRolesPermitidos?.includes(currentUser?.role)) {
      getDescPaq(currentUser.id);
    }
    if (arrRolesPermitidos.includes(currentHostUser.role) && ['cajero'].includes(currentUser.role)) {
      getDescPaq(currentHostUser.id);
    }
  }, [currentHostUser.id, currentHostUser.role, currentUser.id, currentUser?.role]);

  return (
    <DescuentoCuponesContext.Provider value={{ descPaqueteriaData, descPaqueteriaList }}>
      {children}
    </DescuentoCuponesContext.Provider>
  );
}

export default DescuentoCuponesProvider;
